module.exports = __webpack_public_path__ + "images/jobs/webdesignerQualite.f0388492.jpg";